import React from "react";
import { useTranslation } from "react-i18next";
import AppTable from "../../../../shared/AppTable";
import ValidationErrors from "../../../../components/ValidationErrors";

function DiagnosisTable({ data, loading }) {
  const { t } = useTranslation();
  const hasValidation = (row) =>
    row?.has_validation_error === true ||
    (Array.isArray(row?.validation_errors) && row.validation_errors.length > 0);

  const columns = [
    { header: t("Sequence"), render: (row, index) => index + 1 },
    { header: t("Type"), field: "type" },
    {
      header: t("Code"),
      render: (row) => (
        <span className="font-semibold text-[#0070C2] text-xs">
          {row?.code || "__"}
        </span>
      ),
    },
    { header: t("Description"), field: "description" },
    {
      header: t("On Admission"),
      render: (row) => (row?.on_admission ? t("Yes") : t("No")),
    },
  ];

  return (
    <>
      <AppTable
        columns={columns}
        data={data?.data?.diagnosis || []}
        loading={loading}
        actions={false}
        renderRowBelow={(row) =>
          hasValidation(row) ? (
            <ValidationErrors validationErrors={row.validation_errors} compact />
          ) : null
        }
        getRowSx={(row) => ({
          backgroundColor: hasValidation(row) ? "#FEF3C7" : "transparent",
          "&:hover": {
            backgroundColor: hasValidation(row)
              ? "#FDE68A !important"
              : "rgba(0, 0, 0, 0.04)",
          },
        })}
      />
    </>
  );
}

export default DiagnosisTable;
